import { GetActiveZtudents as DLGetActiveZtudents } from './../../DL/Instructor/ZtudentView'

import { LogErrors } from './../../LogErrors'


// wsMonitor.js
// Conector WebSocket simple para el flujo Instructor ↔ Ztudiante (Snapshots)
// - Reintentos con backoff fijo (3s)
// - Buffer de mensajes para no perderlos si el handler aún no está listo
// - API mínima: connectInstructor, disconnect, isReady, send, setMessageHandler

let socket = null
let isConnected = false
let reconnectTimeout = null
let reconnectAttempts = 0
const MAX_RECONNECT_ATTEMPTS = 10

let pendingMessages = []
let currentMessageHandler = null

const _clearTimers = () => {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout)
    reconnectTimeout = null
  }
}

const isReady = () =>
  socket && isConnected && socket.readyState === WebSocket.OPEN

const _installOnMessage = () => {
  socket.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data)

      // Encolamos primero (por si aún no hay handler)
      pendingMessages.push(msg)

      // Si ya hay handler, drenamos cola
      if (typeof currentMessageHandler === 'function') {
        const queue = pendingMessages
        pendingMessages = []
        for (const m of queue) {
          try { currentMessageHandler(m) } catch (err) {
            console.error('[WS] Handler error:', err)
          }
        }
      }
    } catch (err) {
      console.error('[WS] Error parseando mensaje:', err)
    }
  }
}

function _resetWsState() {
  try {
    if (socket) {
      socket.onopen = null
      socket.onclose = null
      socket.onerror = null
      socket.onmessage = null
      try { socket.close() } catch {}
    }
  } catch {}
  socket = null
  isConnected = false
  _clearTimers()
  // No limpiamos pendingMessages para no perder mensajes tardíos (opcional)
}

function disconnect() {
  _resetWsState()
  reconnectAttempts = 0
}

function setMessageHandler(handler) {
  currentMessageHandler = typeof handler === 'function' ? handler : null

  // Si ya hay cola, drénala ahora
  if (typeof currentMessageHandler === 'function' && pendingMessages.length > 0) {
    const queue = pendingMessages
    pendingMessages = []
    for (const msg of queue) {
      try { currentMessageHandler(msg) } catch (e) { console.error('[WS] handler error:', e) }
    }
  }
}

// Conexión como INSTRUCTOR
// opts: { urlWss, centerId, user, name, surname, onStatusChange?, onToast? }
function connectInstructor(opts) {
  const {
    urlWss,
    centerId,
    user,
    name = '',
    surname = '',
    onStatusChange = () => {},
    onToast = () => {}
  } = opts || {}

  if (!urlWss) throw new Error('urlWss requerido (wss://…/ws)')
  if (!centerId || !user) throw new Error('centerId y user son requeridos para Instructor')

  if (socket || isConnected) return // evitar doble conexión

  const connect = () => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatusChange('error')
      console.warn('[WS] Límite de reconexiones alcanzado')
      return
    }

    reconnectAttempts++
    // Ejemplo: wss://api.tu-dominio.com/ws?centerId=C1&role=instructor&user=inst1&name=Ana&surname=Lopez
    const url = `${urlWss}?centerId=${encodeURIComponent(centerId)}&role=instructor&user=${encodeURIComponent(user)}&name=${encodeURIComponent(name)}&surname=${encodeURIComponent(surname)}`
    socket = new WebSocket(url)
    onStatusChange('Conectando...')

    socket.onopen = () => {
      isConnected = true
      reconnectAttempts = 0
      onStatusChange('Conectado')
      onToast('Conectado al monitor de Ztudiantes')
    }

    socket.onclose = () => {
      isConnected = false
      socket = null
      onStatusChange('Reconectando...')
      reconnectTimeout = setTimeout(connect, 3000)
    }

    socket.onerror = (e) => {
      console.error('[WS] Error de conexión:', e)
      onStatusChange('error')
    }

    _installOnMessage()
  }

  connect()
}

function send(obj) {
  if (!isReady()) return false
  try {
    socket.send(JSON.stringify(obj))
    return true
  } catch (err) {
    console.error('[WS] Error al enviar:', err)
    return false
  }
}

const WsMonitor = {
  connectInstructor,
  disconnect,
  isReady,
  send,
  setMessageHandler
}

const GetActiveZtudents = async () => {
  try {
    const response = await DLGetActiveZtudents()

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

export { WsMonitor, GetActiveZtudents };